module.exports = __webpack_public_path__ + "static/img/my-info-bg.cdee550.png";